import { useSessionActions } from '@btime/react-session'
import React, { useEffect } from 'react'

import { usePermalinkToken } from '../../../utils/session/permalinkToken'
import Loading from '../../../components/helpers/Loading'

const PermalinkAuth = ({ children, token }) => {
  const storedToken = usePermalinkToken()
  const { setPermalinkToken } = useSessionActions()
  useEffect(() => {
    setPermalinkToken(token)
  }, [token])

  if (!storedToken) return <Loading />
  return children
}

export default PermalinkAuth
